import { Box, Flex, Spacer } from "@chakra-ui/react"
import { useRecoilValue } from "recoil"
import LiveIcon from "../../../common/icons/live-icon"
import { brandingSelector } from "../../../../recoil/atoms/room"
import { LocalMuteIcon } from "../../buttons-main-screen/local-mute-icon"
import { LeaveMeetingButton } from "../../leave-overlay"
import DragToResizeIcon from "../controls-player/drag-to-resize-icon"
import { useCallback } from "react"
import { AvatarMuteIcon } from "../../buttons-main-screen/avatar-mute-icon"
import { AvatarMicControl } from "../../buttons-main-screen/avatar-mic-control"
import useConfig from "src/hooks/useConfig"

type PlayerPanelProps = {
  isMobile: boolean
  showLiveIcon?: boolean
  showLocalSpeakerIcon?: boolean
  showAvatarSpeakerIcon?: boolean
  showAvatarMicIcon?: boolean
  showDragToResizeIcon: boolean
  showLeaveButton: boolean
}

const PlayerPanel = ({
  isMobile,
  showLiveIcon = true,
  showLocalSpeakerIcon = true,
  showAvatarSpeakerIcon = false,
  showAvatarMicIcon = false,
  showDragToResizeIcon,
  showLeaveButton
}: PlayerPanelProps) => {
  const roomStyles = useRecoilValue(brandingSelector)
  const config = useConfig()

  const rowDirection = isMobile && config.swapLeaveAndMicSpeakerButtonPositions ? "row-reverse" : "row"

  // stop propagation
  const handleStopPropagation = useCallback(event => {
    event.stopPropagation()
  }, [])

  return (
    <Flex 
      width={"100%"}
      flexDirection={rowDirection}
      height={"50px"}
      background={"rgba(0, 0, 0, 0.6)"}
      borderTop="none"
      
      paddingStart="2"
      paddingEnd="2"

      onClick={handleStopPropagation} 
      >
      <Flex
        justifyContent="center"
        alignItems="center"
      >

        {showLiveIcon && <LiveIcon paddingRight={"4px"}/> }
        {showLocalSpeakerIcon && <LocalMuteIcon />}
        
        {showAvatarSpeakerIcon && <AvatarMuteIcon style={{ padding: "4px" }} />}
        {showAvatarMicIcon && <AvatarMicControl  style={{ padding: "4px" }} />}
      
      </Flex>


      {showDragToResizeIcon && <DragToResizeIcon />}

      <Box flexGrow={1}></Box>

      {showLeaveButton && (
        <Box
          padding="10px 0px 10px 0"
          position="relative"
        >
          <LeaveMeetingButton
            showBackIcon={isMobile && !!config.swapLeaveAndMicSpeakerButtonPositions}
            color={roomStyles?.servicePanelElementBorder}
            backgroundColor={roomStyles?.servicePanelElementBorderOffset}
          />
        </Box>
      )}
    </Flex>
  )
}

export default PlayerPanel
